// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const GROUP_ASKED_TO_JOIN = "Po\u017eiadala si o \u010dlenstvo";
export const GROUP_ASK_TO_JOIN = "Po\u017eiadaj o \u010dlenstvo";
export const GROUP_YOU_ARE_BLOCKED = "Pr\u00edstup do skupiny ti bol zablokovan\u00fd";
export const JOIN_GROUP = "Pridaj sa ku skupine";
export const LEAVE_GROUP = "Opusti\u0165 skupinu";
export const num_POSTS_AND_ANSWERS_IN_LAST_WEEK = ["%(num)s \u010dlovek prispel za t\u00fd\u017ede\u0148", "%(num)s \u013eudia prispeli za t\u00fd\u017ede\u0148", "%(num)s \u013eud\u00ed prispelo za t\u00fd\u017ede\u0148"];
